import { FC, PropsWithChildren } from 'react'
import {
  FieldValues,
  FormProvider,
  useForm,
  UseFormProps,
} from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z, ZodSchema } from 'zod'

interface Props extends Omit<UseFormProps, 'resolver'> {
  formSchema?: ZodSchema
  // Read once on mount. Use `values` for data that changes after mount.
  defaultValues?: FieldValues
  // TODO: Seeing as this a proxy of a useFormProps, we should pass the actual prop 'disabled'
  isReadOnly?: boolean
}

export const FormWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  formSchema = z.any(),
  defaultValues,
  isReadOnly,
  ...props
}) => {
  const formMethods = useForm({
    ...props,
    resolver: zodResolver(formSchema),
    disabled: isReadOnly,
    defaultValues,
  })

  return <FormProvider {...formMethods}>{children}</FormProvider>
}
